import { Component, OnInit } from '@angular/core';

// import { REPORTS } from '../models/reports';
import { PagerService } from '../services/pager.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import Utils from '../shared/utility';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  private reports: any[];
  private error:string;

  private allItems: any[];
  private filteredReports: any[];
  pager: any = {};
  pagedItems: any[];

  private role: any;

  activeFirstNameArrow: boolean;
  activeOrgNameArrow: boolean;
  activAdvisorNameArrow: boolean;
  activeDateArrow: boolean;

  constructor(private pagerService: PagerService, private globalService: GlobalService, private snackBarService: SnackBarService, private loadingService: LoadingService) { 
    this.getReports();
  }

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    
    // this.allItems = REPORTS;
    // this.filteredReports = REPORTS;
    // this.setPage(1);
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredReports.length, page);

    // get current page of items
    this.pagedItems = this.filteredReports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  assignCopy(){
    this.filteredReports = Object.assign([], this.allItems);
  }

  // filterItem(value){
  //     if(!value) this.assignCopy();
  //     // console.log(this.allItems);
  //     this.filteredReports = Object.assign([], this.allItems).filter(
  //       report => ((report.c.FirstName + " " + report.c.LastName).toLowerCase().includes(value.toLowerCase()))
  //     )
  //     // console.log(this.filteredReports);
  //     this.setPage(1);
  // }

  filterItem(value){
    // console.log(value);
    //if(!value) this.assignCopy();
    this.filteredReports = Object.assign([], this.allItems).filter(
      report => {
        return (report.c.FirstName + " " + report.c.LastName + " " + report.c.spouseName).toLowerCase().includes(value.toLowerCase()) || (report.o.Name).toLowerCase().includes(value.toLowerCase()) || (report.a.FirstName + " " + report.a.LastName).toLowerCase().includes(value.toLowerCase())
      }
    );
    
    if (!this.filteredReports.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
}

  getReports() {
    this.loadingService.isLoading(true);
    this.globalService.getReportsData()
        .subscribe(
            reports => { 
              var allReports = [];

              // console.log(reports);

              for (var type in reports) {
                reports[type].forEach((report) => {                

                  if (report.ss) { 
                    report.c.spouseName = report.ss.MaritalState == 'Married' ? report.ss.FrmName1 : '';
                  } else if (report.mmt) {                   
                    report.c.spouseName = report.mmt.IncludePartner == 'True' ? report.mmt.FrmName1 : '';
                  } else if (report.hc) {
                    report.c.spouseName = report.hc.FrmIncome.toLowerCase().includes('mfj') ? report.hc.FrmName1.includes('undefined') ? report.hc.FrmName1.replace('undefined', '') : report.hc.FrmName1 : '';
                  } else if (report.ltc) {                
                    report.c.spouseName = report.ltc.FrmHasPartner == 'True' ? report.ltc.FrmName1 : '';
                  }

                  allReports.push(report);
                });
              }

              // console.log(allReports);

              this.reports = allReports;        
                        
              // this.advisors = advisors;
              this.allItems = this.reports;
              // console.log(this.filteredReports);

              this.filteredReports = this.reports.sort(function(a, b) {
                return parseInt(b.r.ID) - parseInt(a.r.ID);
              });

              // console.log(this.filteredReports);
              
              this.setPage(1);
              this.loadingService.isLoading(false);
              // console.log(reports);
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
            });
  }

  downloadReport(e, report) {
     console.log(report);
    this.loadingService.isLoading(true);

    var reportID = report.r.ReportID;
    var advisorID = report.r.AdvisorID;
    var clientID = report.r.ClientID;
    var orgID = report.r.CompanyCode;
    var reportTypeID = report.r.ReportTypeID;

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer"), retirementAge: report.c.RetirementAge };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);
    
    this.globalService.generateReport(ReportFields, report.c, report.r)
      .subscribe(
      resp => {
        // console.log('downloading report');
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' +  Utils.parseDateTime(date) : '--';
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID);
  }

  disableAllSortArrow() {
    this.activeFirstNameArrow = false;
    this.activeOrgNameArrow = false;
    this.activAdvisorNameArrow = false;
    this.activeDateArrow = false;
  }

  private isColSortedAsc: any = {
    FirstName: false,
    OrganizationName: false,
    AdvisorName: false,
    Date: false,
  }

  sort(colName) {
    this.disableAllSortArrow();
    if (colName == 'FirstName') {
      this.filteredReports.sort((a, b) => this.isColSortedAsc[colName] ? a.c.FirstName.trim().localeCompare(b.c.FirstName.trim()) : b.c.FirstName.trim().localeCompare(a.c.FirstName.trim()));
      this.setPage(this.pager.currentPage);
      this.activeFirstNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'OrganizationName') {
      this.filteredReports.sort((a, b) => this.isColSortedAsc[colName] ? a.o.Name.localeCompare(b.o.Name ) : b.o.Name.localeCompare(a.o.Name ));
      this.setPage(this.pager.currentPage);
      this.activeOrgNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'AdvisorName') {
      this.filteredReports.sort((a, b) => this.isColSortedAsc[colName] ? a.a.FirstName.localeCompare(b.a.FirstName ) : b.a.FirstName.localeCompare(a.a.FirstName ));
      this.setPage(this.pager.currentPage);
      this.activAdvisorNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'Date') {
      this.filteredReports.sort((a, b) => this.isColSortedAsc[colName] ? Date.parse(a.r.Created_Date) - Date.parse(b.r.Created_Date) : Date.parse(b.r.Created_Date) - Date.parse(a.r.Created_Date));
      this.setPage(this.pager.currentPage);
      this.activeDateArrow = this.isColSortedAsc[colName];
    }

    this.isColSortedAsc[colName] = !this.isColSortedAsc[colName];
  }

  toggleRiskToleranceID(id) {
    let isLTC = id === 4;
    let isHC = id === 3;

    if (isLTC)
      return 6;
    if (isHC)
      return 5;
    return id;
  }
}
